export var EmailBlockTypeEnum;
(function (EmailBlockTypeEnum) {
    EmailBlockTypeEnum["BUTTON"] = "button";
    EmailBlockTypeEnum["TEXT"] = "text";
})(EmailBlockTypeEnum || (EmailBlockTypeEnum = {}));
export var TextAlignEnum;
(function (TextAlignEnum) {
    TextAlignEnum["CENTER"] = "center";
    TextAlignEnum["LEFT"] = "left";
    TextAlignEnum["RIGHT"] = "right";
})(TextAlignEnum || (TextAlignEnum = {}));
export var ButtonTypeEnum;
(function (ButtonTypeEnum) {
    ButtonTypeEnum["PRIMARY"] = "primary";
    ButtonTypeEnum["SECONDARY"] = "secondary";
})(ButtonTypeEnum || (ButtonTypeEnum = {}));
export var MessageActionStatusEnum;
(function (MessageActionStatusEnum) {
    MessageActionStatusEnum["PENDING"] = "pending";
    MessageActionStatusEnum["DONE"] = "done";
})(MessageActionStatusEnum || (MessageActionStatusEnum = {}));
